import React, { useState, useEffect } from 'react';
import { SafeAreaView, View, Text, StyleSheet, TouchableOpacity, Dimensions, ScrollView, RefreshControl, StatusBar, Alert, Modal, FlatList, ActivityIndicator, TextInput } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';

const { width } = Dimensions.get('window');
const PRIMARY = '#0e4e96'; const SECONDARY = '#1e7be2';
const API_BASE_URL = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const api = axios.create({ baseURL: API_BASE_URL, timeout: 15000, headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-API-Key': API_KEY } });
api.interceptors.request.use(async c => { try { const t = await AsyncStorage.getItem('auth_token')||await AsyncStorage.getItem('token'); if(t)c.headers.Authorization=`Bearer ${t}`; }catch{} return c; });
const EP = { companyProfile:(id)=>`/api/company-profile/${id}`, deals:'/api/data/crm_deals', contacts:'/api/data/crm_contacts', activities:'/api/data/crm_activities', stages:'/api/data/crm_stages', opportunities:'/api/data/opportunities', clients:'/api/clients', employees:'/api/employees' };
const getBusinessId=async()=>{try{return await AsyncStorage.getItem('company_id')||await AsyncStorage.getItem('company_id')||'0';}catch{return '0';}};
const safeData=r=>(r?.data?.success&&Array.isArray(r.data.data))?r.data.data:[];

export default function OpportunityScreen({ navigation, route }) {
  const [isLoading, setIsLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [activeTab, setActiveTab] = useState('opportunities');
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [filterStage, setFilterStage] = useState('all');
  const [filterPriority, setFilterPriority] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [companyId, setCompanyId] = useState(null);
  const [companyProfile, setCompanyProfile] = useState(null);
  const [opportunities, setOpportunities] = useState([]);
  const [stages, setStages] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [activities, setActivities] = useState([]);
  const [stats, setStats] = useState({ total:0, totalValue:0, avgValue:0, wonCount:0, lostCount:0, openCount:0, winRate:0, avgProbability:0 });
  const [newOpp, setNewOpp] = useState({ company:'', contactName:'', contactEmail:'', value:'', stage:'lead', priority:'medium', source:'direct', notes:'' });

  const stagesList = ['all','lead','contacted','qualified','proposal','negotiation','closed_won','closed_lost'];
  const priorities = ['all','low','medium','high','critical'];

  useEffect(()=>{init();},[]);
  const init=async()=>{try{setIsLoading(true);const b=route?.params?.company_id||await getBusinessId();setCompanyId(b);await fetchAll(b);}catch(e){console.error(e);}finally{setIsLoading(false);}};
  const onRefresh=async()=>{setRefreshing(true);await init();setRefreshing(false);};

  const fetchAll=async(bizId)=>{
    const cid=parseInt(bizId)||0;const p={company_id:cid};
    const [profileRes,dealsRes,oppsRes,contactsRes,activitiesRes,stagesRes]=await Promise.allSettled([
      api.get(EP.companyProfile(cid)),api.get(EP.deals,{params:p}),api.get(EP.opportunities,{params:p}),
      api.get(EP.contacts,{params:p}),api.get(EP.activities,{params:p}),api.get(EP.stages),
    ]);
    const profile=profileRes.status==='fulfilled'?(profileRes.value?.data?.success?(Array.isArray(profileRes.value.data.data)?profileRes.value.data.data[0]:profileRes.value.data.data):null):null;
    if(profile){setCompanyProfile(profile);await AsyncStorage.setItem('company_profile',JSON.stringify(profile));}
    else{try{const c=await AsyncStorage.getItem('company_profile');if(c)setCompanyProfile(JSON.parse(c));}catch{}}

    const deals=safeData(dealsRes.status==='fulfilled'?dealsRes.value:null);
    const opps=safeData(oppsRes.status==='fulfilled'?oppsRes.value:null);
    const cts=safeData(contactsRes.status==='fulfilled'?contactsRes.value:null);
    const acts=safeData(activitiesRes.status==='fulfilled'?activitiesRes.value:null);
    const stgs=safeData(stagesRes.status==='fulfilled'?stagesRes.value:null);

    setContacts(cts);
    setActivities(acts);
    setStages(stgs.length>0?stgs:[{stage_id:'lead',name:'Lead',color:'#94a3b8'},{stage_id:'contacted',name:'Contacted',color:'#3b82f6'},{stage_id:'qualified',name:'Qualified',color:'#f59e0b'},{stage_id:'proposal',name:'Proposal',color:'#8b5cf6'},{stage_id:'negotiation',name:'Negotiation',color:'#ec4899'},{stage_id:'closed_won',name:'Won',color:'#10b981'},{stage_id:'closed_lost',name:'Lost',color:'#ef4444'}]);

    // Merge deals + opportunities
    const allOpps=deals.map(d=>({
      id:String(d.id),name:d.contact_name||'Unknown',company:d.company||'',email:d.contact_email||'',
      phone:d.contact_phone||'',stage:d.stage||'lead',value:parseFloat(d.value||0),
      probability:d.probability||0,priority:d.priority||'medium',source:d.source||'direct',
      notes:d.notes||'',assignedTo:d.assigned_to,tags:d.tags||[],
      createdAt:d.created_at,updatedAt:d.updated_at,dealId:d.id,clientId:d.client_id,
      nextAction:d.next_action||'',dueDate:d.due_date,
    }));
    opps.forEach(o=>{if(!allOpps.find(a=>a.email===o.email&&a.company===(o.company||o.company_name))){
      allOpps.push({id:`opp-${o.id}`,name:o.contact_name||o.name||'',company:o.company||o.company_name||'',
        email:o.email||'',phone:o.phone||'',stage:o.stage||o.status||'lead',value:parseFloat(o.value||o.amount||0),
        probability:o.probability||o.win_probability||0,priority:o.priority||'medium',source:o.source||'direct',
        notes:o.notes||'',createdAt:o.created_at,updatedAt:o.updated_at});
    }});
    setOpportunities(allOpps);

    const won=allOpps.filter(o=>o.stage==='closed_won'||o.stage==='won');
    const lost=allOpps.filter(o=>o.stage==='closed_lost'||o.stage==='lost');
    const open=allOpps.filter(o=>!['closed_won','won','closed_lost','lost'].includes(o.stage));
    const totalVal=allOpps.reduce((s,o)=>s+o.value,0);
    setStats({
      total:allOpps.length,totalValue:totalVal,avgValue:allOpps.length>0?totalVal/allOpps.length:0,
      wonCount:won.length,lostCount:lost.length,openCount:open.length,
      winRate:allOpps.length>0?(won.length/allOpps.length*100):0,
      avgProbability:allOpps.length>0?allOpps.reduce((s,o)=>s+o.probability,0)/allOpps.length:0,
    });
  };

  const createOpportunity=async()=>{
    if(!newOpp.company||!newOpp.contactName){Alert.alert('Required','Company and contact name are required');return;}
    try{
      await api.post(EP.deals,{company:newOpp.company,contact_name:newOpp.contactName,contact_email:newOpp.contactEmail,
        stage:newOpp.stage,value:parseFloat(newOpp.value)||0,probability:10,priority:newOpp.priority,
        source:newOpp.source,notes:newOpp.notes,company_id:parseInt(companyId)||0,tags:[]});
      Alert.alert('Created','Opportunity created');
      setShowAddModal(false);setNewOpp({company:'',contactName:'',contactEmail:'',value:'',stage:'lead',priority:'medium',source:'direct',notes:''});
      await fetchAll(companyId);
    }catch(e){Alert.alert('Error',e.message);}
  };

  const updateStage=async(opp,newStage)=>{
    try{if(opp.dealId)await api.put(`${EP.deals}/${opp.dealId}`,{stage:newStage});
      Alert.alert('Updated',`Moved to ${newStage}`);setShowModal(false);await fetchAll(companyId);
    }catch(e){Alert.alert('Error',e.message);}
  };

  const deleteOpp=opp=>{
    Alert.alert('Delete',`Delete ${opp.name}?`,[{text:'Cancel',style:'cancel'},{text:'Delete',style:'destructive',onPress:async()=>{
      try{if(opp.dealId)await api.delete(`${EP.deals}/${opp.dealId}`);Alert.alert('Deleted');await fetchAll(companyId);}catch(e){Alert.alert('Error',e.message);}
    }}]);
  };

  const formatCurrency=v=>new Intl.NumberFormat('en-GB',{style:'currency',currency:companyProfile?.currency||'GBP',minimumFractionDigits:0,maximumFractionDigits:0}).format(v||0);
  const formatDate=d=>d?new Date(d).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}):'';
  const getStageColor=s=>({lead:'#6B7280',new:'#6B7280',contacted:'#3B82F6',qualified:'#F59E0B',proposal:'#8B5CF6',negotiation:'#EC4899',closed_won:'#10B981',won:'#10B981',closed_lost:'#EF4444',lost:'#EF4444'}[s]||'#6B7280');
  const getPriorityColor=p=>({critical:'#EF4444',high:'#F59E0B',medium:'#3B82F6',low:'#10B981'}[p]||'#6B7280');

  const filtered=opportunities.filter(o=>{
    if(filterStage!=='all'&&o.stage!==filterStage)return false;
    if(filterPriority!=='all'&&o.priority!==filterPriority)return false;
    if(searchQuery){const q=searchQuery.toLowerCase();return `${o.name} ${o.company} ${o.email}`.toLowerCase().includes(q);}
    return true;
  });

  const renderHeader=()=>(
    <LinearGradient colors={[PRIMARY,SECONDARY]} style={st.header}>
      <View style={st.headerRow}>
        <TouchableOpacity onPress={()=>navigation?.goBack()} style={st.hBtn}><MaterialCommunityIcons name="arrow-left" size={24} color="#FFF"/></TouchableOpacity>
        <View style={st.hCenter}><Text style={st.hTitle}>{companyProfile?.name||'Opportunities'}</Text>
          <Text style={st.hSub}>{companyProfile?.industry?`${companyProfile.industry} · `:''}{stats.total} opportunities · {formatCurrency(stats.totalValue)}</Text></View>
        <TouchableOpacity onPress={()=>setShowAddModal(true)} style={st.hBtn}><MaterialCommunityIcons name="plus" size={24} color="#FFF"/></TouchableOpacity>
      </View>
      {companyProfile&&<View style={st.chips}>
        {companyProfile.headquarters&&<View style={st.chip}><MaterialCommunityIcons name="map-marker" size={12} color="#93C5FD"/><Text style={st.chipTxt}>{companyProfile.headquarters}</Text></View>}
        {companyProfile.employee_count&&<View style={st.chip}><MaterialCommunityIcons name="account-group" size={12} color="#93C5FD"/><Text style={st.chipTxt}>{companyProfile.employee_count} team</Text></View>}
      </View>}
    </LinearGradient>
  );

  const renderStats=()=>(
    <ScrollView horizontal showsHorizontalScrollIndicator={false} style={st.statsBar} contentContainerStyle={{paddingHorizontal:16}}>
      {[{l:'Open',v:stats.openCount,c:PRIMARY},{l:'Won',v:stats.wonCount,c:'#10B981'},{l:'Lost',v:stats.lostCount,c:'#EF4444'},
        {l:'Win Rate',v:`${stats.winRate.toFixed(1)}%`,c:'#8B5CF6'},{l:'Avg Value',v:formatCurrency(stats.avgValue),c:'#F59E0B'},
        {l:'Pipeline',v:formatCurrency(stats.totalValue),c:'#3B82F6'}].map((s2,i)=>(
        <View key={i} style={st.statCard}><Text style={[st.statVal,{color:s2.c}]}>{s2.v}</Text><Text style={st.statLbl}>{s2.l}</Text></View>
      ))}
    </ScrollView>
  );

  const renderFilters=()=>(
    <View style={st.filters}>
      <View style={st.searchRow}><MaterialCommunityIcons name="magnify" size={20} color="#9CA3AF"/>
        <TextInput style={st.searchInput} placeholder="Search..." placeholderTextColor="#9CA3AF" value={searchQuery} onChangeText={setSearchQuery}/>
        {searchQuery?<TouchableOpacity onPress={()=>setSearchQuery('')}><MaterialCommunityIcons name="close" size={18} color="#9CA3AF"/></TouchableOpacity>:null}
      </View>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{marginTop:8}}>
        {stagesList.map(s2=>(
          <TouchableOpacity key={s2} style={[st.fChip,filterStage===s2&&{backgroundColor:getStageColor(s2)||PRIMARY}]} onPress={()=>setFilterStage(s2)}>
            <Text style={[st.fChipTxt,filterStage===s2&&{color:'#FFF'}]}>{s2==='all'?'All Stages':s2.replace('closed_','').replace('_',' ').replace(/\b\w/g,c=>c.toUpperCase())}</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );

  const renderTabs=()=>(
    <View style={st.tabsRow}><ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{paddingHorizontal:12}}>
      {[{k:'opportunities',t:'All',i:'briefcase'},{k:'pipeline',t:'Pipeline',i:'pipe'},{k:'analytics',t:'Analytics',i:'chart-bar'}].map(tab=>(
        <TouchableOpacity key={tab.k} style={[st.tab,activeTab===tab.k&&st.activeTab]} onPress={()=>setActiveTab(tab.k)}>
          <MaterialCommunityIcons name={tab.i} size={18} color={activeTab===tab.k?PRIMARY:'#6B7280'}/>
          <Text style={[st.tabTxt,activeTab===tab.k&&{color:PRIMARY,fontWeight:'600'}]}>{tab.t}</Text>
        </TouchableOpacity>
      ))}
    </ScrollView></View>
  );

  const renderOppCard=opp=>(
    <TouchableOpacity key={opp.id} style={st.card} onPress={()=>{setSelected(opp);setShowModal(true);}}>
      <View style={st.cardHeader}>
        <View style={{flex:1}}>
          <Text style={st.cardName}>{opp.name}</Text>
          <Text style={st.cardMeta}>{opp.company}{opp.source?` · ${opp.source}`:''}</Text>
        </View>
        <View style={{alignItems:'flex-end'}}>
          {opp.value>0&&<Text style={st.cardValue}>{formatCurrency(opp.value)}</Text>}
          <View style={[st.badge,{backgroundColor:getStageColor(opp.stage)+'20'}]}>
            <Text style={[st.badgeTxt,{color:getStageColor(opp.stage)}]}>{opp.stage.replace('closed_','').replace('_',' ')}</Text>
          </View>
        </View>
      </View>
      <View style={st.cardFooter}>
        <Text style={st.cardFooterTxt}>{opp.priority} · {opp.probability}% prob</Text>
        <Text style={st.cardDate}>{formatDate(opp.createdAt)}</Text>
      </View>
      {opp.probability>0&&<View style={st.probBar}><View style={[st.probFill,{width:`${opp.probability}%`,backgroundColor:opp.probability>50?'#10B981':'#F59E0B'}]}/></View>}
    </TouchableOpacity>
  );

  const renderPipeline=()=>(
    <View style={st.section}>
      <Text style={st.secTitle}>Pipeline by Stage</Text>
      {stages.map((stg,idx)=>{
        const stgOpps=opportunities.filter(o=>o.stage===stg.stage_id||o.stage===stg.name?.toLowerCase());
        const stgVal=stgOpps.reduce((s2,o)=>s2+o.value,0);
        return (
          <View key={idx} style={st.pipeStage}>
            <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
              <View style={{flexDirection:'row',alignItems:'center'}}>
                <View style={[st.dot,{backgroundColor:stg.color||'#6B7280'}]}/>
                <Text style={st.pipeName}>{stg.name}</Text>
                <View style={[st.badge,{backgroundColor:(stg.color||'#6B7280')+'20',marginLeft:8}]}><Text style={[st.badgeTxt,{color:stg.color||'#6B7280'}]}>{stgOpps.length}</Text></View>
              </View>
              <Text style={st.pipeVal}>{formatCurrency(stgVal)}</Text>
            </View>
            {stgOpps.slice(0,3).map(o=>(
              <TouchableOpacity key={o.id} style={st.miniCard} onPress={()=>{setSelected(o);setShowModal(true);}}>
                <Text style={st.miniName}>{o.name}</Text>
                <Text style={st.miniCo}>{o.company}</Text>
                {o.value>0&&<Text style={st.miniVal}>{formatCurrency(o.value)}</Text>}
              </TouchableOpacity>
            ))}
            {stgOpps.length>3&&<Text style={st.more}>+{stgOpps.length-3} more</Text>}
          </View>
        );
      })}
    </View>
  );

  const renderAnalytics=()=>{
    const srcMap={};opportunities.forEach(o=>{srcMap[o.source||'unknown']=(srcMap[o.source||'unknown']||0)+1;});
    const stgMap={};opportunities.forEach(o=>{stgMap[o.stage||'unknown']=(stgMap[o.stage||'unknown']||0)+1;});
    return (
      <View style={st.section}>
        <Text style={st.secTitle}>Opportunity Analytics</Text>
        <View style={st.grid}>
          {[{l:'Total Value',v:formatCurrency(stats.totalValue),c:'#10B981'},{l:'Avg Deal',v:formatCurrency(stats.avgValue),c:'#3B82F6'},
            {l:'Win Rate',v:`${stats.winRate.toFixed(1)}%`,c:'#8B5CF6'},{l:'Avg Prob',v:`${stats.avgProbability.toFixed(0)}%`,c:'#F59E0B'}].map((m,i)=>(
            <View key={i} style={st.gridCard}><Text style={[st.gridVal,{color:m.c}]}>{m.v}</Text><Text style={st.gridLbl}>{m.l}</Text></View>
          ))}
        </View>
        <Text style={[st.secTitle,{marginTop:20}]}>By Source</Text>
        {Object.entries(srcMap).sort((a,b)=>b[1]-a[1]).map(([src,cnt],i)=>(
          <View key={i} style={st.barRow}><Text style={st.barLbl}>{src}</Text>
            <View style={st.barBg}><View style={[st.barFill,{width:`${(cnt/opportunities.length)*100}%`}]}/></View>
            <Text style={st.barCnt}>{cnt}</Text>
          </View>
        ))}
        <Text style={[st.secTitle,{marginTop:20}]}>By Stage</Text>
        {Object.entries(stgMap).sort((a,b)=>b[1]-a[1]).map(([stg,cnt],i)=>(
          <View key={i} style={st.barRow}>
            <View style={{flexDirection:'row',alignItems:'center',width:100}}><View style={[st.dot,{backgroundColor:getStageColor(stg),marginRight:6}]}/><Text style={st.barLbl}>{stg.replace('closed_','')}</Text></View>
            <View style={st.barBg}><View style={[st.barFill,{width:`${(cnt/opportunities.length)*100}%`,backgroundColor:getStageColor(stg)}]}/></View>
            <Text style={st.barCnt}>{cnt}</Text>
          </View>
        ))}
      </View>
    );
  };

  const renderContent=()=>{
    const wrap=ch=><ScrollView style={{flex:1}} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} colors={[PRIMARY]}/>} showsVerticalScrollIndicator={false}>{ch}<View style={{height:40}}/></ScrollView>;
    switch(activeTab){
      case 'opportunities':return wrap(<>{renderFilters()}{filtered.length===0?<View style={st.empty}><MaterialCommunityIcons name="briefcase-outline" size={48} color="#D1D5DB"/><Text style={st.emptyTxt}>No opportunities found</Text><TouchableOpacity style={st.emptyBtn} onPress={()=>setShowAddModal(true)}><Text style={st.emptyBtnTxt}>+ Add Opportunity</Text></TouchableOpacity></View>:filtered.map(renderOppCard)}</>);
      case 'pipeline':return wrap(renderPipeline());
      case 'analytics':return wrap(renderAnalytics());
      default:return null;
    }
  };

  const renderDetailModal=()=>(
    <Modal visible={showModal} animationType="slide" presentationStyle="pageSheet" onRequestClose={()=>setShowModal(false)}>
      <View style={st.modal}><View style={st.modalH}>
        <Text style={st.modalTitle}>{selected?.name||'Opportunity'}</Text>
        <TouchableOpacity style={st.modalClose} onPress={()=>setShowModal(false)}><MaterialCommunityIcons name="close" size={24} color="#6B7280"/></TouchableOpacity>
      </View>
      {selected&&<ScrollView style={{flex:1,padding:16}}>
        <View style={st.mSec}><Text style={st.mSecTitle}>Contact</Text>
          <Text style={st.mTxt}>Company: {selected.company}</Text><Text style={st.mTxt}>Name: {selected.name}</Text>
          {selected.email&&<Text style={st.mTxt}>Email: {selected.email}</Text>}
          {selected.phone&&<Text style={st.mTxt}>Phone: {selected.phone}</Text>}</View>
        <View style={st.mSec}><Text style={st.mSecTitle}>Details</Text>
          <Text style={st.mTxt}>Stage: {selected.stage}</Text><Text style={st.mTxt}>Value: {formatCurrency(selected.value)}</Text>
          <Text style={st.mTxt}>Probability: {selected.probability}%</Text><Text style={st.mTxt}>Priority: {selected.priority}</Text>
          <Text style={st.mTxt}>Source: {selected.source}</Text><Text style={st.mTxt}>Created: {formatDate(selected.createdAt)}</Text>
          {selected.notes&&<Text style={st.mTxt}>Notes: {selected.notes}</Text>}</View>
        {companyProfile&&<View style={st.mSec}><Text style={st.mSecTitle}>Company</Text><Text style={st.mTxt}>{companyProfile.name}{companyProfile.industry?` · ${companyProfile.industry}`:''}</Text></View>}
        <View style={st.mSec}><Text style={st.mSecTitle}>Move to Stage</Text>
          <View style={st.stageButtons}>
            {['contacted','qualified','proposal','negotiation','closed_won','closed_lost'].map(s2=>(
              <TouchableOpacity key={s2} style={[st.stageBtn,{borderColor:getStageColor(s2)}]} onPress={()=>updateStage(selected,s2)}>
                <Text style={[st.stageBtnTxt,{color:getStageColor(s2)}]}>{s2.replace('closed_','').replace('_',' ')}</Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
        <TouchableOpacity style={st.delBtn} onPress={()=>{setShowModal(false);deleteOpp(selected);}}>
          <MaterialCommunityIcons name="delete" size={18} color="#EF4444"/><Text style={st.delBtnTxt}>Delete</Text>
        </TouchableOpacity>
      </ScrollView>}</View>
    </Modal>
  );

  const renderAddModal=()=>(
    <Modal visible={showAddModal} animationType="slide" presentationStyle="pageSheet" onRequestClose={()=>setShowAddModal(false)}>
      <View style={st.modal}><View style={st.modalH}>
        <Text style={st.modalTitle}>Add Opportunity</Text>
        <TouchableOpacity style={st.modalClose} onPress={()=>setShowAddModal(false)}><MaterialCommunityIcons name="close" size={24} color="#6B7280"/></TouchableOpacity>
      </View>
      <ScrollView style={{flex:1,padding:16}}>
        {[{k:'company',l:'Company *',p:'TechCorp Ltd'},{k:'contactName',l:'Contact Name *',p:'John Smith'},{k:'contactEmail',l:'Email',p:'john@company.com',kb:'email-address'},{k:'value',l:'Value (£)',p:'50000',kb:'numeric'},{k:'notes',l:'Notes',p:'Notes...',ml:true}].map(f=>(
          <View key={f.k} style={st.formField}><Text style={st.formLbl}>{f.l}</Text>
            <TextInput style={[st.formInput,f.ml&&{height:80,textAlignVertical:'top'}]} placeholder={f.p} placeholderTextColor="#9CA3AF" value={newOpp[f.k]} onChangeText={v=>setNewOpp({...newOpp,[f.k]:v})} keyboardType={f.kb||'default'} multiline={f.ml}/></View>
        ))}
        <View style={st.formField}><Text style={st.formLbl}>Priority</Text>
          <View style={{flexDirection:'row'}}>{['low','medium','high','critical'].map(p=>(
            <TouchableOpacity key={p} style={[st.fChip,newOpp.priority===p&&{backgroundColor:getPriorityColor(p)}]} onPress={()=>setNewOpp({...newOpp,priority:p})}>
              <Text style={[st.fChipTxt,newOpp.priority===p&&{color:'#FFF'}]}>{p}</Text></TouchableOpacity>
          ))}</View></View>
        <View style={st.formField}><Text style={st.formLbl}>Source</Text>
          <ScrollView horizontal showsHorizontalScrollIndicator={false}>
            {['website','referral','linkedin','trade-show','cold-call','direct'].map(s2=>(
              <TouchableOpacity key={s2} style={[st.fChip,newOpp.source===s2&&{backgroundColor:PRIMARY}]} onPress={()=>setNewOpp({...newOpp,source:s2})}>
                <Text style={[st.fChipTxt,newOpp.source===s2&&{color:'#FFF'}]}>{s2}</Text></TouchableOpacity>
            ))}</ScrollView></View>
        <TouchableOpacity style={st.submitBtn} onPress={createOpportunity}>
          <MaterialCommunityIcons name="check" size={20} color="#FFF"/><Text style={st.submitBtnTxt}>Create Opportunity</Text></TouchableOpacity>
        <View style={{height:40}}/>
      </ScrollView></View>
    </Modal>
  );

  if(isLoading)return <SafeAreaView style={st.loading}><StatusBar barStyle="dark-content"/><ActivityIndicator size="large" color={PRIMARY}/><Text style={st.loadingTxt}>Loading opportunities...</Text></SafeAreaView>;

  return (
    <SafeAreaView style={st.container}><StatusBar barStyle="light-content"/>
      {renderHeader()}{renderStats()}{renderTabs()}{renderContent()}{renderDetailModal()}{renderAddModal()}
    </SafeAreaView>
  );
}

const st=StyleSheet.create({
  container:{flex:1,backgroundColor:'#F3F4F6'},loading:{flex:1,justifyContent:'center',alignItems:'center',backgroundColor:'#F3F4F6'},loadingTxt:{fontSize:16,color:'#6B7280',marginTop:16},
  header:{paddingTop:8,paddingBottom:16,paddingHorizontal:16},headerRow:{flexDirection:'row',alignItems:'center'},hBtn:{width:40,height:40,borderRadius:20,backgroundColor:'rgba(255,255,255,0.12)',justifyContent:'center',alignItems:'center'},hCenter:{flex:1,marginLeft:12},hTitle:{fontSize:20,fontWeight:'bold',color:'#FFF'},hSub:{fontSize:13,color:'#93C5FD',marginTop:2},
  chips:{flexDirection:'row',flexWrap:'wrap',marginTop:10,gap:6},chip:{flexDirection:'row',alignItems:'center',backgroundColor:'rgba(255,255,255,0.08)',borderRadius:12,paddingHorizontal:8,paddingVertical:4},chipTxt:{color:'#93C5FD',fontSize:11,marginLeft:4},
  statsBar:{flexGrow:0,flexShrink:0,backgroundColor:'#FFF',paddingVertical:12,borderBottomWidth:1,borderBottomColor:'#E5E7EB'},statCard:{alignItems:'center',marginRight:16,minWidth:70},statVal:{fontSize:16,fontWeight:'bold'},statLbl:{fontSize:11,color:'#6B7280',marginTop:2},
  tabsRow:{backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E5E7EB'},tab:{flexDirection:'row',alignItems:'center',paddingHorizontal:14,paddingVertical:10,marginRight:4,borderRadius:20},activeTab:{backgroundColor:'#EFF6FF'},tabTxt:{fontSize:13,color:'#6B7280',marginLeft:6,fontWeight:'500'},
  filters:{backgroundColor:'#FFF',padding:12,margin:16,borderRadius:12,borderWidth:1,borderColor:'#E5E7EB'},
  searchRow:{flexDirection:'row',alignItems:'center',backgroundColor:'#F3F4F6',borderRadius:8,paddingHorizontal:10,paddingVertical:8},searchInput:{flex:1,fontSize:14,color:'#1F2937',marginLeft:8},
  fChip:{paddingHorizontal:12,paddingVertical:6,borderRadius:16,backgroundColor:'#F3F4F6',marginRight:6,marginTop:4},fChipTxt:{fontSize:12,color:'#6B7280',fontWeight:'500'},
  section:{backgroundColor:'#FFF',margin:16,padding:16,borderRadius:12,borderWidth:1,borderColor:'#E5E7EB'},secTitle:{fontSize:17,fontWeight:'bold',color:'#1F2937',marginBottom:12},
  card:{backgroundColor:'#FFF',marginHorizontal:16,marginBottom:8,padding:14,borderRadius:10,borderWidth:1,borderColor:'#E5E7EB'},
  cardHeader:{flexDirection:'row',justifyContent:'space-between',alignItems:'flex-start'},cardName:{fontSize:15,fontWeight:'600',color:'#1F2937'},cardMeta:{fontSize:12,color:'#6B7280',marginTop:1},
  cardValue:{fontSize:14,fontWeight:'700',color:'#10B981'},badge:{borderRadius:10,paddingHorizontal:8,paddingVertical:2,marginTop:4},badgeTxt:{fontSize:11,fontWeight:'600',textTransform:'capitalize'},
  cardFooter:{flexDirection:'row',justifyContent:'space-between',marginTop:8},cardFooterTxt:{fontSize:12,color:'#9CA3AF'},cardDate:{fontSize:12,color:'#9CA3AF'},
  probBar:{height:4,backgroundColor:'#E5E7EB',borderRadius:2,marginTop:8,overflow:'hidden'},probFill:{height:'100%',borderRadius:2},
  empty:{alignItems:'center',padding:32},emptyTxt:{fontSize:16,color:'#6B7280',marginTop:12},emptyBtn:{backgroundColor:PRIMARY,paddingHorizontal:20,paddingVertical:10,borderRadius:8,marginTop:12},emptyBtnTxt:{color:'#FFF',fontWeight:'600'},
  pipeStage:{marginBottom:16},pipeName:{fontSize:15,fontWeight:'600',color:'#1F2937',marginLeft:8},pipeVal:{fontSize:14,fontWeight:'700',color:'#10B981'},
  dot:{width:10,height:10,borderRadius:5},miniCard:{backgroundColor:'#F9FAFB',borderRadius:8,padding:10,marginBottom:4,flexDirection:'row',alignItems:'center',justifyContent:'space-between'},miniName:{fontSize:13,fontWeight:'600',color:'#1F2937'},miniCo:{fontSize:12,color:'#6B7280'},miniVal:{fontSize:13,fontWeight:'600',color:'#10B981'},more:{fontSize:12,color:'#9CA3AF',marginTop:4,textAlign:'center'},
  grid:{flexDirection:'row',flexWrap:'wrap',justifyContent:'space-between'},gridCard:{width:(width-64)/2,backgroundColor:'#F9FAFB',borderRadius:10,padding:14,alignItems:'center',marginBottom:8},gridVal:{fontSize:18,fontWeight:'bold'},gridLbl:{fontSize:12,color:'#6B7280',marginTop:4},
  barRow:{flexDirection:'row',alignItems:'center',marginBottom:8},barLbl:{fontSize:13,color:'#1F2937',width:100},barBg:{flex:1,height:6,backgroundColor:'#E5E7EB',borderRadius:3,marginHorizontal:8,overflow:'hidden'},barFill:{height:'100%',backgroundColor:PRIMARY,borderRadius:3},barCnt:{fontSize:13,fontWeight:'600',color:'#1F2937',width:30,textAlign:'right'},
  modal:{flex:1,backgroundColor:'#FFF'},modalH:{flexDirection:'row',alignItems:'center',justifyContent:'space-between',padding:16,borderBottomWidth:1,borderBottomColor:'#E5E7EB'},modalTitle:{fontSize:18,fontWeight:'bold',color:'#1F2937',flex:1},modalClose:{width:40,height:40,borderRadius:20,backgroundColor:'#F3F4F6',justifyContent:'center',alignItems:'center'},
  mSec:{marginBottom:20},mSecTitle:{fontSize:16,fontWeight:'600',color:'#1F2937',marginBottom:8},mTxt:{fontSize:14,color:'#6B7280',lineHeight:22},
  stageButtons:{flexDirection:'row',flexWrap:'wrap',gap:8},stageBtn:{borderWidth:1.5,borderRadius:8,paddingHorizontal:14,paddingVertical:8},stageBtnTxt:{fontSize:13,fontWeight:'600',textTransform:'capitalize'},
  delBtn:{flexDirection:'row',alignItems:'center',justifyContent:'center',marginTop:24,padding:12,borderRadius:8,backgroundColor:'#FEF2F2'},delBtnTxt:{color:'#EF4444',fontWeight:'600',marginLeft:6},
  formField:{marginBottom:16},formLbl:{fontSize:14,fontWeight:'600',color:'#1F2937',marginBottom:6},formInput:{backgroundColor:'#F3F4F6',borderRadius:8,padding:12,fontSize:14,color:'#1F2937',borderWidth:1,borderColor:'#E5E7EB'},
  submitBtn:{flexDirection:'row',alignItems:'center',justifyContent:'center',backgroundColor:PRIMARY,borderRadius:10,padding:14,marginTop:8},submitBtnTxt:{color:'#FFF',fontWeight:'700',fontSize:16,marginLeft:8},
});